// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"error"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3L12 15.5M12 20H12.0039V20.0039H12V20Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ErrorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'error',
    ref,
    icon: element,
  },
));

ErrorIcon.displayName = 'ErrorIcon';

export default ErrorIcon;
